import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "./pagination";

const Paginate = ({ currentPage, setCurrentPage, totalPages }) => {
  //   const [currentPage, setCurrentPage] = useState(1);
  //   const [totalPages] = useState(7);

  return (
    <Pagination>
      <PaginationContent>
        {parseInt(currentPage) > 1 && (
          <div className="!border rounded-full border-gray-500 dark:border-gray-300 size-8 bg-white">
            <PaginationItem>
              <PaginationPrevious
                onClick={() =>
                  setCurrentPage(
                    parseInt(currentPage) - 1 || parseInt(currentPage)
                  )
                }
                disabled={currentPage === 1}
                className=" hover:text-secondaryColor rounded-full p-0"
                href="#"
              />
            </PaginationItem>
          </div>
        )}

        <div
          onClick={() => setCurrentPage(1)}
          className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
            currentPage == 1 && "bg-secondaryColor !text-white"
          }`}
        >
          <PaginationItem>
            <PaginationLink
              className={`hover:text-secondaryColor p-0`}
              textColor={
                currentPage == 1 ? "text-white" : "dark:text-[#c7d8eb]"
              }
              href="#"
            >
              1
            </PaginationLink>
          </PaginationItem>
        </div>
        {currentPage >= 4 && (
          <div
            onClick={() => setCurrentPage(currentPage - 3)}
            className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center"
          >
            <PaginationItem>
              <PaginationEllipsis className="hover:text-secondaryColor size-full cursor-pointer rounded-full p-0" />
            </PaginationItem>
          </div>
        )}
        {(currentPage > 2 && (
          <>
            <div
              onClick={() =>
                setCurrentPage(
                  (currentPage > 1 && currentPage - 1) || currentPage
                )
              }
              className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center"
            >
              <PaginationItem>
                <PaginationLink
                  className={`hover:bg-secondaryColor size-9 rounded-full p-0 hover:text-white`}
                  textColor={"dark:text-[#c7d8eb]"}
                  href="#"
                >
                  {currentPage - 1}
                </PaginationLink>
              </PaginationItem>
            </div>
            <div
              onClick={() => setCurrentPage(1)}
              className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center bg-secondaryColor"
            >
              <PaginationItem>
                <PaginationLink
                  onClick={() => setCurrentPage(1)}
                  className={`size-9 rounded-full p-0`}
                  textColor={"text-white"}
                  href="#"
                >
                  {currentPage}
                </PaginationLink>
              </PaginationItem>
            </div>
            {currentPage < totalPages && totalPages - currentPage > 1 && (
              <div
                onClick={() =>
                  setCurrentPage(
                    (currentPage < totalPages && currentPage + 1) || currentPage
                  )
                }
                className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center"
              >
                <PaginationItem>
                  <PaginationLink
                    className={`hover:bg-secondaryColor size-9 rounded-full p-0 hover:text-white`}
                    href="#"
                  >
                    {currentPage + 1}
                  </PaginationLink>
                </PaginationItem>
              </div>
            )}
          </>
        )) || (
          <>
            {totalPages > 2 && (
              <div
                onClick={() => setCurrentPage(2)}
                className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
                  currentPage == 2 && "bg-secondaryColor !text-white"
                }`}
              >
                <PaginationItem>
                  <PaginationLink
                    className={`hover:text-secondaryColor size-9 rounded-full p-0`}
                    textColor={
                      currentPage == 2 ? "text-white" : "dark:text-[#c7d8eb]"
                    }
                    href="#"
                  >
                    2
                  </PaginationLink>
                </PaginationItem>
              </div>
            )}
            {totalPages > 3 && (
              <div
                onClick={() => setCurrentPage(3)}
                className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
                  currentPage == 3 && "bg-secondaryColor !text-white"
                }`}
              >
                <PaginationItem>
                  <PaginationLink
                    className={`hover:text-secondaryColor size-9 rounded-full p-0`}
                    textColor={
                      currentPage == 3 ? "text-white" : "dark:text-[#c7d8eb]"
                    }
                    href="#"
                  >
                    3
                  </PaginationLink>
                </PaginationItem>
              </div>
            )}
          </>
        )}
        {(currentPage == 1 && totalPages - currentPage >= 5 && (
          <div
            onClick={() => setCurrentPage(currentPage + 3)}
            className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center"
          >
            <PaginationItem>
              <PaginationEllipsis className="hover:text-secondaryColor size-9 cursor-pointer rounded-full p-0" />
            </PaginationItem>
          </div>
        )) ||
          (totalPages - currentPage >= 3 && (
            <div
              onClick={() => setCurrentPage(currentPage + 3)}
              className=" size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center"
            >
              <PaginationItem>
                <PaginationEllipsis className="hover:text-secondaryColor size-9 cursor-pointer rounded-full p-0" />
              </PaginationItem>
            </div>
          ))}

        {(currentPage == 1 && totalPages - currentPage >= 5 && (
          <div
            onClick={() => setCurrentPage(totalPages)}
            className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
              currentPage == totalPages && "bg-secondaryColor !text-white"
            }`}
          >
            <PaginationItem>
              <PaginationLink
                className={`hover:text-secondaryColor size-9 rounded-full p-0`}
                textColor={
                  currentPage == totalPages
                    ? "text-white"
                    : "dark:text-[#c7d8eb]"
                }
                href="#"
              >
                {totalPages}
              </PaginationLink>
            </PaginationItem>
          </div>
        )) ||
          // here
          (totalPages - currentPage >= 1 && (
            <div
              onClick={() => setCurrentPage(totalPages)}
              className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
                currentPage == totalPages && "bg-secondaryColor !text-white"
              }`}
            >
              <PaginationItem>
                <PaginationLink
                  className={`hover:text-secondaryColor p-0`}
                  textColor={
                    currentPage == totalPages
                      ? "text-white"
                      : "dark:text-[#c7d8eb]"
                  }
                  href="#"
                >
                  {totalPages}
                </PaginationLink>
              </PaginationItem>
            </div>
          )) ||
          (currentPage == totalPages && currentPage == 2 && (
            <div
              onClick={() => setCurrentPage(totalPages)}
              className={`size-8 cursor-pointer !border rounded-full border-gray-500 dark:border-gray-300 flex justify-center items-center ${
                currentPage == totalPages && "bg-secondaryColor !text-white"
              }`}
            >
              <PaginationItem>
                <PaginationLink
                  className={`hover:text-secondaryColor size-9 rounded-full p-0`}
                  textColor={
                    currentPage == totalPages
                      ? "text-white"
                      : "dark:text-[#c7d8eb]"
                  }
                  href="#"
                >
                  {totalPages}
                </PaginationLink>
              </PaginationItem>
            </div>
          ))}

        {parseInt(currentPage) !== parseInt(totalPages) &&
          parseInt(currentPage) < parseInt(totalPages) && (
            <div className="!border rounded-full border-gray-500 dark:border-gray-300 size-8 bg-white">
              <PaginationItem>
                <PaginationNext
                  onClick={() =>
                    setCurrentPage(
                      (parseInt(currentPage) < parseInt(totalPages) &&
                        parseInt(currentPage) + 1) ||
                        parseInt(currentPage)
                    )
                  }
                  className="rounded-full p-0"
                  href="#"
                />
              </PaginationItem>
            </div>
          )}
      </PaginationContent>
    </Pagination>
  );
};

export default Paginate;
